export default __webpack_public_path__ + "static/media/close-status.67febd73.svg";